import { render } from "./ErxOnboardingModal.vue?vue&type=template&id=2949966c&scoped=true"
import script from "./ErxOnboardingModal.vue?vue&type=script&lang=js"
export * from "./ErxOnboardingModal.vue?vue&type=script&lang=js"

import "./ErxOnboardingModal.vue?vue&type=style&index=0&id=2949966c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2949966c"]])

export default __exports__